import {name, version, description} from '../../package.json'

export const WEBSITE_NAME = process.env.REACT_APP_WEBSITE_NAME
export const SHA = process.env.REACT_APP_SHA || Date.now()
export const TURNSTILE_API_ENDPOINT = process.env.REACT_APP_TURNSTILE_API_ENDPOINT
export const AUTH_HEADER = process.env.REACT_APP_AUTH_HEADER

export {
  name,
  version,
  description
}



// WEBPACK FOOTER //
// ./src/services/constants.js